import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { base44 } from "@/api/base44Client";
import CarouselRail from "@/components/yts/CarouselRail";
import StayCard from "@/components/realestate/StayCard";
import { useLang } from "@/lib/i18n";
import { STAY_TYPES } from "@/lib/stays";

/** Every kind of stay the guide knows — hotels, campsites, glamping, one-off rooms. */
export default function HotelsRail() {
  const { lang } = useLang();
  const es = lang === "es";
  const [hotels, setHotels] = useState([]);

  useEffect(() => {
    let live = true;
    base44.entities.RealEstateListing.filter(
      { status: "Published", listing_type: "Short stay", property_type: { $in: STAY_TYPES } },
      { sort: "-created_date", limit: 12 }
    ).then((page) => {
      if (!live) return;
      const items = page.items || [];
      setHotels([...items.filter((item) => item.featured), ...items.filter((item) => !item.featured)].slice(0, 8));
    });
    return () => {
      live = false;
    };
  }, []);

  if (hotels.length === 0) return null;

  return (
    <CarouselRail
      title={es ? "Dónde dormir" : "Hotels & stays"}
      subtitle={es ? "Una selección de lugares únicos por toda la isla. Explora y visita cada hospedaje." : "Distinctive places around the island. Discover them here and visit their websites."}
      itemWidth="w-[min(58vw,216px)] sm:w-[240px]"
      action={
        <Link to="/?section=stays" className="inline-flex items-center gap-1 text-[11px] font-extrabold text-[#171717] transition hover:text-[#ef4036]">
          {es ? "Ver todos" : "See all"}
          <ArrowUpRight aria-hidden="true" className="h-3.5 w-3.5" />
        </Link>
      }
    >
      {hotels.map((hotel) => <StayCard key={hotel.id} listing={hotel} es={es} />)}
    </CarouselRail>
  );
}